export const ExcludeBaseBorderProps = [
    'linecap', 'linejoin',
];

// 暂时不支持compoundType
export const ExcludeMoreBorderProps = [
    'tailEnd', 'headEnd', 'compoundType',
].concat(ExcludeBaseBorderProps);

export const ExcludeBackgroundProps = [
    'id', 'syncLoad',
];

export const ExcludeSketchBorderProps = [
    'bgShape', 'controlValues', 'pathList',
].concat(ExcludeBaseBorderProps);
